// extracted by mini-css-extract-plugin
export var cookieDisclaimer = "layout-module--cookieDisclaimer--c1447";
export var cookieDisclaimerButtonAgree = "layout-module--cookieDisclaimerButtonAgree--68ec3";
export var cookieDisclaimerButtonDecline = "layout-module--cookieDisclaimerButtonDecline--6d3aa";